import { HttpContextToken, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { TracingService } from '../../backend/tracing.service';
import { AuthenticationService } from './authentication.service';
import { DomainService } from './domain.service';

export const skipAdminHeaders = new HttpContextToken(() => false);

/**
 * An HTTP client interceptor, that adds the required authentication headers to the request.
 * Headers are only added, when the request targets the configured 'environment.backendUrl'.
 */
export function authHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthenticationService);
  const domainService = inject(DomainService);
  const tracingService = inject(TracingService);

  if (!domainService.isCDFUrl(req.url)) return next(req);

  let headers = req.headers;

  const authHeaderObject = req.context.get(skipAdminHeaders)
    ? authService.authHeadersWithoutAdminDpNr()
    : authService.authHeaders();

  authHeaderObject?.forEach((value, key) => {
    headers = headers.set(key, value);
  });
  tracingService.tracingHeaders().forEach((value, key) => {
    headers = headers.set(key, value);
  });

  const reqWithHeaders = req.clone({ headers: headers });
  return next(reqWithHeaders);
}
